export class CustomFieldEdit {
  id: number;
  name: string;
  type: string;
  isRequired: boolean;
  isChecked: boolean;
}
